<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-12">
              <card
                :title="stats.users.title"
                :value="stats.users.value"
                :percentage="stats.users.percentage"
                :iconClass="stats.users.iconClass"
                :iconBackground="stats.users.iconBackground"
                :detail="stats.users.detail"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <card
                :title="stats.clients.title"
                :value="stats.clients.value"
                :percentage="stats.clients.percentage"
                :iconClass="stats.clients.iconClass"
                :iconBackground="stats.clients.iconBackground"
                :percentageColor="stats.clients.percentageColor"
                :detail="stats.clients.detail"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <card
                :title="stats.money.title"
                :value="stats.money.value"
                :percentage="stats.money.percentage"
                :iconClass="stats.money.iconClass"
                :iconBackground="stats.money.iconBackground"
                :detail="stats.money.detail"
                directionReverse
              ></card>
            </div>

            <div class="col-lg-3 col-md-6 col-12">
              <card
                :title="stats.sales.title"
                :value="stats.sales.value"
                :percentage="stats.sales.percentage"
                :iconClass="stats.sales.iconClass"
                :iconBackground="stats.sales.iconBackground"
                :detail="stats.sales.detail"
                directionReverse
              ></card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-7 mb-lg">
              <!-- line chart -->
              <div class="card z-index-2">
                <gradient-line-chart />
              </div>
            </div>
            <div class="col-lg-5">
              <categories-card />
            </div>
          </div>
          <!-- <div class="row mt-4">
            <div class="col-lg-7 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Sales by Country</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr v-for="(sale, index) in sales" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div>
                              <img :src="sale.flag" alt="Country flag" />
                            </div>
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Country:</p>
                              <h6 class="mb-0 text-sm">{{ sale.country }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Sales:</p>
                            <h6 class="mb-0 text-sm">{{ sale.sales }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Value:</p>
                            <h6 class="mb-0 text-sm">{{ sale.value }}</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Bounce:</p>
                            <h6 class="mb-0 text-sm">{{ sale.bounce }}</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              
            </div>
          </div> -->
        </div>
      </div>
    </div>
</template>
  <script>
  import Card from "@/examples/Cards/Card.vue";
  import GradientLineChart from "@/views/clinic-lab/Dashboard/Components/Charts/GradientLineChart.vue";
  import CategoriesCard from "@/views/clinic-lab/Dashboard/Components/Cards/CategoriesCard.vue";

  import US from "@/assets/img/icons/flags/US.png";
  import DE from "@/assets/img/icons/flags/DE.png";
  import GB from "@/assets/img/icons/flags/GB.png";
  import BR from "@/assets/img/icons/flags/BR.png";
  
  export default {
    name: "dashboard-default",
    data() {
      return {
        stats: {
          money: {
            title: "Compras",
            value: "7",
            percentage: "",
            iconClass: "fa fa-money-bill",
            detail: " ",
            iconBackground: "bg-success",
          },
          users: {
            title: "Clientes",
            value: "250",
            percentage: "",
            iconClass: "fa fa-users",
            iconBackground: "bg-success",
            detail: " ",
          },
          clients: {
            title: "Facturas",
            value: "20",
            percentage: "",
            iconClass: "fa fa-file-invoice-dollar",
            percentageColor: "text-danger",
            iconBackground: "bg-success",
            detail: " ",
          },
          sales: {
            title: "Facturas en mora",
            value: "10",
            percentage: "",
            iconClass: "fa fa-file-invoice-dollar",
            iconBackground: "bg-warning",
            detail: " ",
          },
        },
        sales: {
          us: {
            country: "United States",
            sales: 2500,
            value: "$230,900",
            bounce: "29.9%",
            flag: US,
          },
          germany: {
            country: "Germany",
            sales: "3.900",
            value: "$440,000",
            bounce: "40.22%",
            flag: DE,
          },
          britain: {
            country: "Great Britain",
            sales: "1.400",
            value: "$190,700",
            bounce: "23.44%",
            flag: GB,
          },
          brasil: {
            country: "Brasil",
            sales: "562",
            value: "$143,960",
            bounce: "32.14%",
            flag: BR,
          },
        },
      };
    },
    components: {
      Card,
      GradientLineChart,
      CategoriesCard,
    },
  };
  </script>
  